import Timer from '../../modules/timer/Timer/TimerPage';

const TimerPage = () => {
  return <Timer />;
};

export default TimerPage;
